import React, { useState } from 'react';
import Markdown from './Markdown';
import { CreativePayload } from '../services/ai';
import './CreativeMessageCard.css';

// 编导创意任务的结构化结果卡片：
// - 每个【字段】独立成节，长内容（脚本/分镜/提示词）默认折叠
// - 提示词类字段一键复制，可直接粘贴给 AI 视频模型
// - payload 缺失时回退为纯 Markdown 渲染

const CreativeMessageCard: React.FC<{ creative: CreativePayload; content: string }> = ({ creative, content }) => {
  const sections = creative.sections && creative.sections.length > 0 ? creative.sections : null;
  const [copiedKey, setCopiedKey] = useState<string | null>(null);

  const copy = async (key: string, text: string) => {
    try {
      await navigator.clipboard.writeText(text);
      setCopiedKey(key);
      setTimeout(() => setCopiedKey(null), 1600);
    } catch {
      // 剪贴板失败静默
    }
  };

  if (!sections) {
    return <Markdown content={content} />;
  }

  return (
    <div className="cre-card">
      <div className="cre-card-head">
        <span className="cre-card-tag">{creative.label}</span>
        <span className="cre-card-note">结构化方案 · 长内容可折叠</span>
      </div>
      {sections.map(section => (
        <CreativeSectionBlock
          key={section.key}
          section={section}
          copied={copiedKey === section.key}
          onCopy={() => copy(section.key, section.text)}
        />
      ))}
    </div>
  );
};

const CreativeSectionBlock: React.FC<{
  section: { key: string; title: string; text: string; collapsible: boolean; copyable: boolean };
  copied: boolean;
  onCopy: () => void;
}> = ({ section, copied, onCopy }) => {
  const [open, setOpen] = useState(!section.collapsible);

  return (
    <div className={`cre-sec ${section.collapsible ? 'cre-sec-fold' : ''}`}>
      <div className="cre-sec-head">
        {section.collapsible ? (
          <button className="cre-sec-title-btn" onClick={() => setOpen(o => !o)}>
            <span className="cre-sec-title">【{section.title}】</span>
            <span className="cre-sec-chevron">{open ? '▾' : '▸'}</span>
          </button>
        ) : (
          <span className="cre-sec-title">【{section.title}】</span>
        )}
        <div className="cre-sec-actions">
          {section.copyable && (
            <button className="cre-sec-copy" onClick={onCopy}>
              {copied ? '已复制' : '复制提示词'}
            </button>
          )}
          {section.collapsible && (
            <button className="cre-sec-toggle" onClick={() => setOpen(o => !o)}>
              {open ? '收起' : '展开'}
            </button>
          )}
        </div>
      </div>
      {open && (
        <div className="cre-sec-body">
          <Markdown content={section.text} />
        </div>
      )}
    </div>
  );
};

export default CreativeMessageCard;
